export const shareButtons = [
  // {
  //   imgSrc: require("@/assets/images/icons/share-modal/facebook.svg"),
  //   imgAlt: "Facebook Button",
  //   subtitle: "Facebook",
  // },
  {
    imgSrc: require("@/assets/images/icons/share-modal/instagram.svg"),
    imgAlt: "Instagram Button",
    subtitle: "Instagram",
  },
  // {
  //   imgSrc: require("@/assets/images/icons/share-modal/email.svg"),
  //   imgAlt: "Email Button",
  //   subtitle: "Email",
  // },
];
